import 'css-chunksrc/client/scenes/comments/feed/placeholder/styles.scss';export default {
  "placeholder": "_placeholder_1lvy5_1",
  "icon": "_icon_1lvy5_9"
};